import { ApiFilters } from '../../../core/models/interfaces/api-filters.interface';
import { DeviceResponseDto } from '../../devices/models/device-response.interface';
import { DeviceSortBy, DeviceSortDir } from '../../devices/state/device.state';

export const FEATURE_NAME = 'pumpState';

export interface PumpState {
  entities: Record<string, DeviceResponseDto>; // Cache for the actual pump objects
  error: any | null;
  isLoading: boolean;
  filter: PumpFilter;
  pages: Record<number, string[]>; // Page number to pump ids on that page
  totalCount: number;
  connectedValves: Record<string, DeviceResponseDto[]>; // Pump id to its connected valves
  isConnectedValvesLoading: boolean;
}

export interface PumpFilter extends ApiFilters {
  isActive?: boolean;
  isOutOfService?: boolean;
  isFavorite?: boolean;
  sortBy?: DeviceSortBy;
  sortDir?: DeviceSortDir;
}

export const initialState: PumpState = {
  entities: {},
  filter: {
    page: 0,
    pageSize: 12,
    isOutOfService: false,
    sortBy: 'name',
    sortDir: 'asc',
  },
  pages: {},
  totalCount: 0,
  isLoading: false,
  error: null,
  connectedValves: {},
  isConnectedValvesLoading: false,
}
